// Hash router. Patterns: '/', '/login', '/workout/:code', '/session/:id',
// '/history', '/history/:id', '/prs', '/evolution', '/settings'.

export type Route = {
  pattern: string;
  render: (params: Record<string, string>) => void | Promise<void>;
};

const routes: Route[] = [];
let notFound: Route['render'] = () => {};

export function on(pattern: string, render: Route['render']) {
  routes.push({ pattern, render });
}

export function onNotFound(render: Route['render']) {
  notFound = render;
}

export function navigate(path: string) {
  if (location.hash !== `#${path}`) {
    location.hash = path;
  } else {
    void dispatch();
  }
}

export function current(): string {
  return location.hash.replace(/^#/, '') || '/';
}

function pathOnly(p: string): string {
  // Drop ?query and #fragment from a route string.
  const q = p.indexOf('?');
  return q >= 0 ? p.slice(0, q) : p;
}

function match(pattern: string, path: string): Record<string, string> | null {
  const a = pattern.split('/').filter(Boolean);
  const b = pathOnly(path).split('/').filter(Boolean);
  if (a.length !== b.length) return null;
  const params: Record<string, string> = {};
  for (let i = 0; i < a.length; i++) {
    const pa = a[i]!;
    const pb = b[i]!;
    if (pa.startsWith(':')) params[pa.slice(1)] = decodeURIComponent(pb);
    else if (pa !== pb) return null;
  }
  return params;
}

export async function dispatch() {
  const path = current();
  for (const r of routes) {
    const params = match(r.pattern, path);
    if (params) {
      await r.render(params);
      return;
    }
  }
  await notFound({});
}

export function startRouter() {
  window.addEventListener('hashchange', () => void dispatch());
  void dispatch();
}
